
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFuse01 as ObiFuse01Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-fuse-01.js';
 
 
 

 
 export const ObiFuse01 = createComponent({
   react: React,
   tagName: 'obi-fuse-01',
   elementClass: ObiFuse01Element,
   events: {
     
   }
  });
 
 